import { render } from "./CareerFairHeroBlock.vue?vue&type=template&id=f947c96c&scoped=true"
import script from "./CareerFairHeroBlock.vue?vue&type=script&lang=js"
export * from "./CareerFairHeroBlock.vue?vue&type=script&lang=js"

import "./CareerFairHeroBlock.vue?vue&type=style&index=0&id=f947c96c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f947c96c"

export default script